import styles from './FullCard.module.css'
import butStyles from '../CSS/ButtonGroup.module.css'

import React, {useContext, useEffect, useRef, useState} from "react";
import {SliderContext} from "./Slider";
import {useDispatch, useSelector} from "react-redux";
import {ReduxStateInt, setBaseRegion, setOrderData, setSlider} from "../Reducer/GlobalReducer";
import useApiQuery from "../ApiQuery/UseApiQuery";
import {AppContext} from "../App";
import WaitLoader from "../WaitLoader/WaitLoader";
import ModalWindow from "../FormTemplate/ModalWindow/ModalWindow";
import {Link, useLocation, useNavigate} from "react-router-dom";
import Review from "./Review/Review";
import {Helmet} from "react-helmet";
import textStyles from "../MainMenu/TextMenu.module.css";
import {renderToReadableStream} from "react-dom/server";
import InputItem, {IRefInputItem} from "../FormTemplate/InputItem/InputItem";

interface FullCardPropsInt
{
    tarifId : string
}


interface IDataCard
{
    [key:string]:any
    tarifId:string
    bundleOne: {
        regionMnpList:string
        actCost:number
    }
    useMNP:boolean
}

export default function FullCard()
{

    const dispatch = useDispatch();
    const location = useLocation()


    const baseRegion = useSelector((state: ReduxStateInt) => {
        return state.baseRegion
    })


    const [tarifId, setTarifId] = useState<string>()



    const slider = useSelector((state: ReduxStateInt) => {
        return state.slider
    })
    const vidWidth =  window.innerWidth-60 < 720 ? window.innerWidth-60 : 500

    const refMnpCtn = useRef<IRefInputItem>(null)



    const [mode, setMode] = useState(1)

    const tarifData_ = useRef({
        regionId:baseRegion.isChanged ? baseRegion?.regionId : -1,
        macroRegionId: baseRegion.isChanged ? baseRegion?.macroRegionId : -1,
        tarifId: tarifId
    })

    const tarifData = useRef<{
        regionId?:number
        macroRegionId?: number
        tarifId: string
    }>()
    const [ldrTarif,rsTarif,exTarif] = useApiQuery("/tarif/list","post",tarifData);
    const [cardData, setCardData] = useState<IDataCard>()
    //const [mnpRegion, setMnpRegion] = useState("")
    const [useMnp, setUseMnp] = useState(false)


    const navigate = useNavigate()

    const containerRef = useRef<HTMLInputElement>(null)
    const btnCheckRef = useRef<HTMLButtonElement>(null)


    const cardTagData = useRef<{
        tarifId:string
    }>()
    const [ldrCardTag,rsCardTag,exCardTag] = useApiQuery("/tarif/card","post",cardTagData);
    const [tagList, setTagList] = useState<any[]>([])




    const [reviewCount,setReviewCount] = useState(0)


    useEffect(()=>{
        if(!location?.pathname) return
        const path = location?.pathname
        const tarifIdPath = path?.match(/(?<=\/tarif\/)[^/]+$/ui)
        if(!tarifIdPath || tarifIdPath[0] === undefined)
        {
            handleMoveHomeSlide()
            return;
        }
        setTarifId(tarifIdPath[0])
    },[location])




    useEffect(()=>{
        loadTarifInRegion()

    },[baseRegion,tarifId, mode])


    useEffect(()=>{
        if(cardData)loadTagList()
        //console.log("DataCard",dataCard)
    },[cardData])


    useEffect(()=>{
        if(containerRef === null) return
        containerRef?.current?.scrollIntoView()
    },[tagList])


    useEffect(()=>{
        if(cardData)resolveMnpUse(cardData?.bundleOne?.regionMnpList)
    },[cardData])



    const resolveMnpUse = (mnpRegionList: string) => {
        console.log("res",mnpRegionList,cardData?.useMNP,baseRegion)
        if(! mnpRegionList) //Если нет никакой возможности mnp то не показываем вообще
        {
            setUseMnp(false)
            return;
        }

        if(cardData?.useMNP !== undefined && !cardData?.useMNP) //Если в самой карточке запрет на mnp не важно из каких регионов
        {
            setUseMnp(false)
            return;
        }
        if(!baseRegion?.isChanged) //Если есть какая либо возможность но регион не выбран показываем
        {
            setUseMnp(true)
            return;
        }


        const x  = mnpRegionList?.split(';')

        const match = x?.filter((item)=>{
            if(item?.match(/all/ui)) return true
            if(baseRegion?.isChanged)
            {
                const m1 = new RegExp("^"+baseRegion?.macroRegionId+"$","ui")
                const m2 = new RegExp("^"+baseRegion?.regionId+"$","ui")
                if(item?.match(m1) || item?.match(m2)) return  true

            }
            return  false

        })

        console.log(`match`, match)
        setUseMnp( match?.length > 0)



    }

    const loadTarifInRegion = () =>{
        if( ! tarifId ) return
        //console.log("loadTarifInRegion", tarifId)
        tarifData.current = {
            regionId : baseRegion?.isChanged ? baseRegion?.regionId : undefined,
            macroRegionId : baseRegion?.isChanged ? baseRegion?.macroRegionId : undefined ,
            tarifId : tarifId,
        }
        exTarif().then((e)=>{
            if(e?.success)
            {
                if(e?.payload && Array.isArray(e?.payload) && e?.payload?.length > 0 )
                {
                    const pr = e?.payload[0]
                    console.log("card data",pr)
                    setCardData(pr)
                    //resolveMnpUse(pr?.bundleOne?.regionMnpList)
                    return
                }

                //Если карта не нашлась уходим на главную
                handleMoveHomeSlide()
            }
        })

    }

    const  loadTagList = () =>
    {
        if(!cardData) return
        cardTagData.current = {
            tarifId: cardData?.tarifId
        }
        exCardTag().then((e)=>{
            if(e?.success )
            {
                setTagList(e?.payload)
                return
            }
        })
    }

    const buildTagList = () =>{
        return tagList.map((item,key)=>{
            if(item.val)item.val = item?.val.replace(/\{\{oper\}\}/ui,cardData?.operOne.name)
            let spClass
            switch (item?.type)
            {
                case 1:
                    spClass = styles.tagLineAdd
                    break
                default: spClass=""
            }

            return(
                    <div key={key} className={styles.tagLinePls}>
                        <p><span className={[ styles.tagLineCaptBld,spClass].join(' ')}>{item?.tagName}<span className={styles.tagLineCapt}>:</span></span>{item?.val}</p>
                    </div>
            )
        })
    }

    const buildTarifContent = () =>{
        const netText = Number(cardData?.netList[0].val) === 9999 ? "безлимит" : cardData?.netList[0].val + " Гб."
        const callText = Number(cardData?.packetList[0].val) === 9999 ? "безлимит" : cardData?.packetList[0].val + " мин."
        return(
            <div className={styles.tfContent}>
                <ul>
                    <li><span>Пакет интернета :</span><span>{netText}</span></li>
                    {(cardData?.type ===0) && <li><span>Голосовой пакет :</span><span>{callText}</span></li>}
                    {(cardData?.type ===0) && <li><span>Пакет SMS :</span><span>{cardData?.smsCount + " шт."}</span></li>}
                </ul>
            </div>
        )
    }










    const regionText = baseRegion?.isChanged ? baseRegion?.regionName : "Любой"





    const buildActivateCost = () =>{
        if(cardData?.bundleOne?.actCost === undefined) return null
        if(cardData?.bundleOne?.actCost === 0) return null
        return (
            <div className={styles.actLine}>
                <div className={styles.actTitle}>Внимание :</div>
                <div className={styles.actText}>Оператор <span>{cardData?.operOne?.name}</span> взимает плату при активации номера в размере <span>{cardData?.bundleOne?.actCost}</span> руб.
                Эти средства списывает оператор связи. Плата взимается единоразово при активации номера.
                </div>
            </div>
        )

    }


    const handleMoveHomeSlide = () =>{
        dispatch(setSlider({sliderMode:0}))
        window.scrollTo({
            top:0
        })
        navigate('/')
    }

    const handleNewOrder = ()=>{
        dispatch(setSlider({
            dataCardItem: cardData,
            selectedTarif: cardData?.tarifId
        }))
        navigate('/order')

    }
    const handleMnpOrder = ()=>{
        dispatch(setSlider({
            dataCardItem: cardData,
            selectedTarif: cardData?.tarifId
        }))
        navigate('/tarif/mnp')

    }


    const buildAction = () =>{
        return(

            <div className={styles.actCover}>
                <div className={styles.actTitleMain}>Способ подключения</div>
                <div className={styles.actCont}>
                    <button type="button" className="btn btn-face"
                            onClick={()=> handleNewOrder()}
                    >Подключить новую sim-карту
                    </button>
                    {useMnp &&
                        <button type="button" className="btn btn-face"
                                onClick={handleMnpOrder}
                        >Перейти со своим номером [ mnp ]
                        </button>

                    }

                </div>

            </div>

        )

    }


    const buildUpNav = () =>{
        return(
            <div className={[styles.btnContainer].join(' ')}>
                    <button type="button" className="btn btn-face"
                            onClick={handleMoveHomeSlide}
                    >Все тарифы
                    </button>
            </div>
        )
    }
    const buildDownNav = () =>{
        return(
            <div className={[styles.btnContainer].join(' ')}>
                <button type="button" className="btn btn-face"
                        onClick={handleMoveHomeSlide}
                >Назад
                </button>
            </div>
        )
    }



    //console.log("data card iten", dataCardItem)
    return(
        <WaitLoader loading={ ldrTarif} api={rsCardTag} onlyLoading={true}>
            <Helmet>
                <title>sim-unlim :  {cardData?.name ? cardData?.name : ""} </title>
                <link rel="canonical" href={`https://sim-unlim.com/tarif/${cardData?.tarifId}`} />
                <meta name="description" content={["описание тарифа ",cardData?.name].join(' ')} />
            </Helmet>
            <div className={styles.tagListContainer}   ref={containerRef}>

                <div className={styles.card}>

                    {buildUpNav()}


                    <div className={styles.tagLine}>
                        <div className={styles.tagCapt}>Оператор</div>
                        <div className={styles.tagCont}>{cardData?.operOne?.name}</div>
                    </div>
                    <div className={styles.tagLine}>
                        <div className={styles.tagCapt}>Название тарифа</div>
                        <div className={styles.tagCont}>{cardData?.name}</div>
                    </div>
                    <div className={styles.tagLine}>
                        <div className={styles.tagCapt}>Регион тарифа</div>
                        <div className={styles.tagCont}>{regionText}</div>
                    </div>

                    <div className={styles.tagLine}>
                        <div className={styles.tagCapt}>Абонентская плата</div>
                        <div className={styles.tagCont}>{cardData?.apList[0]?.val+" руб./мес."}</div>
                    </div>
                    <div className={styles.tagLine}>
                        <div className={styles.tagCapt}>Стоимость подключения</div>
                        <div className={[styles.tagCont,styles.price].join(' ')}>{cardData?.price+" руб."}</div>
                    </div>

                    <div className={styles.tagLine}>
                        <div className={styles.tagCapt}>Подключение со своим номером</div>
                        <div className={[styles.tagCont].join(' ')}>{useMnp ? "Да" : "Нет"}</div>
                    </div>


                    {buildAction()}
                    <div className={styles.tagCenter}>
                        <div><span className={styles.bold}>В абонентскую плату входит</span></div>
                    </div>

                    <div className={styles.tagLine}>
                        {buildTarifContent()}
                    </div>



                    <div className={styles.tagLine}>
                        {buildActivateCost()}
                    </div>
                    <WaitLoader loading={ldrCardTag} api={rsCardTag} onlyLoading={true}>
                        {buildTagList()}
                    </WaitLoader>

                    {buildDownNav()}

                </div>
                {tarifId &&
                    <Review tarifId={tarifId} setReviewCount={setReviewCount}></Review>
                }
                {(reviewCount>5 )&& <> {buildAction()}</>}
            </div>
        </WaitLoader>
    )
}